// extracted by mini-css-extract-plugin
export default {"about":"Jj6aq","title":"y_uAG","description":"m959W","skeleton":"hjT1D"};